import integrationApi from '../api'

const LINEAR_ENDPOINT = 'proxy/linear'
const MAX_PAGES = 10
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

function selectNodes(connection) {
  if (!connection) return []
  if (Array.isArray(connection)) return connection
  return connection.nodes || []
}

function parseProxyResponse({ code, json }) {
  if (code === 200 || code === 201) {
    return Promise.resolve(json)
  }
  if (code >= 400) return Promise.reject(json)
  return Promise.reject()
}

function request(token, operation, variables = {}) {
  return integrationApi
    .post(
      token,
      LINEAR_ENDPOINT,
      null,
      JSON.stringify({ operation, variables })
    )
    .then(parseProxyResponse)
}

async function paginate(token, operation, variables, selectConnection) {
  const nodes = []
  let after
  for (let page = 0; page < MAX_PAGES; page += 1) {
    // Cursor-dependent pagination must remain sequential.
    // eslint-disable-next-line no-await-in-loop
    const data = await request(token, operation, { ...variables, after })
    const connection = selectConnection(data)
    const { nodes: pageNodes = [], pageInfo } = connection || {}
    nodes.push(...(pageNodes || []))
    if (!pageInfo?.hasNextPage) break
    after = pageInfo.endCursor
    if (!after) break
  }
  return nodes
}

export function teams(token) {
  return paginate(token, 'teams', {}, data => data?.data?.teams)
}

export function workflowStates(token, teamId) {
  return paginate(
    token,
    'workflowStates',
    { teamId },
    data => data?.data?.workflowStates
  )
}

export function assignees(token, teamId) {
  return paginate(
    token,
    'assignees',
    { teamId },
    data => data?.data?.team?.members
  )
}

export function labels(token, teamId) {
  return paginate(token, 'labels', { teamId }, data => data?.data?.issueLabels)
}

export function projects(token, teamId) {
  return paginate(token, 'projects', { teamId }, data => data?.data?.projects)
}

export function searchIssues(token, term) {
  return request(token, 'searchIssues', { term }).then(data =>
    selectNodes(data.data.searchIssues)
  )
}

export function issue(token, reference) {
  return request(token, 'issue', reference).then(data => data.data.issue)
}

export function createIssue(token, variables) {
  return request(token, 'createIssue', variables).then(
    data => data.data.issueCreate.issue
  )
}

export function createAttachment(token, variables) {
  return request(token, 'createAttachment', variables).then(data => {
    const attachmentCreate = data?.data?.attachmentCreate
    const attachment = attachmentCreate?.attachment
    if (
      attachmentCreate?.success === true &&
      attachment &&
      typeof attachment === 'object' &&
      !Array.isArray(attachment) &&
      UUID.test(attachment.id)
    ) {
      return attachment
    }
    return Promise.reject(data)
  })
}
